// extracted by mini-css-extract-plugin
module.exports = {"description":"_0fd55ca845--description--dY4lf"};